<template>
  <div>
    <Breadcrumbs main="Candidate" :title="state_intruction.instruction[0].title" />
    <!-- Container-fluid starts-->
    <div class="container-fluid detail-assessment">
      <div class="row">
        <div class="col-xl-12 col-md-12 box-col-12">
          <div class="card">
            <div class="card-body p-0">
              <div class="header-asessment mt-4 mb-4">
                <div class="row">
                  <div class="col-3">
                    <img :src="`https://redwhiteanalytics.com/${state_intruction.instruction[0].icon}`" />
                  </div>

                  <div class="col-9 wording">
                    <h3 class="mb-4">{{ state_intruction.instruction[0].title }}</h3>

                    <p>
                      {{ state_intruction.instruction[0].description }}
                    </p>
                  </div>
                </div>
              </div>
              <template v-if="count_answ >= state_intruction.instruction[0].count_question">
                <ThankYou></ThankYou>
              </template>
              <template v-else>
                <Personality v-if="$route.query.type == 'A'"></Personality>
                <CommunicationStyle
                  v-if="$route.query.type == 'B'"
                ></CommunicationStyle>
                <Leadership v-if="$route.query.type == 'C'"></Leadership>
                <SocialInteraction
                  v-if="$route.query.type == 'D'"
                ></SocialInteraction>
                <ThinkStyle v-if="$route.query.type == 'E'"></ThinkStyle>
                <Numerical v-if="$route.query.type == 'F'"></Numerical>
                <JobPreference v-if="$route.query.type == 'G'"></JobPreference>
                <CaseStudy v-if="$route.query.type == 'H'"></CaseStudy>
                <Survey v-if="$route.query.type == 'I'"></Survey>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import CommunicationStyle from "../../components/asessment/module/CommunicationStyle.vue";
  import Personality from "../../components/asessment/module/Personality.vue";
  import Leadership from "../../components/asessment/module/Leadership.vue";
  import SocialInteraction from "../../components/asessment/module/SocialInteraction.vue";
  import ThinkStyle from "../../components/asessment/module/ThinkStyle.vue";
  import Numerical from "../../components/asessment/module/Numerical.vue";
  import ThankYou from "../../components/asessment/module/ThankYou.vue";
  import { getDataAnswerUser } from '../../_services/asessment.service';
  import JobPreference from '../../components/asessment/module/JobPreference.vue';
  import Survey from '../../components/asessment/module/Survey.vue';
  import CaseStudy from '../../components/asessment/module/CaseStudy.vue';

  export default {
    components: {
    CommunicationStyle,
    Personality,
    Leadership,
    SocialInteraction,
    ThinkStyle,
    Numerical,
    ThankYou,
    JobPreference,
    Survey,
    CaseStudy
},
    data(){
      return {
        state_intruction : '',
        count_answ : ''
      };
    },
    async created() {
      if (this.$route.query.type === "A") {
        this.state_intruction = await this.$store.dispatch("personality/getQuestions", {
          type: this.$route.query.type,
          lang: this.$route.query.lang,
        });
        this.count_answ = this.$store.state.personality.questionResponses.length;
      } else if (this.$route.query.type === "B") {
        this.state_intruction = await this.$store.dispatch("communication/getQuestions", {
          type: this.$route.query.type,
          lang: this.$route.query.lang,
        });
        this.count_answ = this.$store.state.communication.questionResponses.sangat.length;
      } else if (this.$route.query.type === "C") {
        this.state_intruction = await this.$store.dispatch("leadership/getQuestions", {
          type: this.$route.query.type,
          lang: this.$route.query.lang,
        });
        this.count_answ = this.$store.state.leadership.questionResponses.length;
      } else if (this.$route.query.type === "D") {
        this.state_intruction = await this.$store.dispatch("socialInteraction/getQuestions", {
          type: this.$route.query.type,
          lang: this.$route.query.lang,
        });
        this.count_answ = this.$store.state.socialInteraction.questionResponses.length;
      } else if (this.$route.query.type === "E") {
        this.state_intruction = await this.$store.dispatch("thinkStyle/getQuestions", {
          type: this.$route.query.type,
          lang: this.$route.query.lang,
        });
        this.count_answ = this.$store.state.thinkStyle.questionResponses.length;
      } else if (this.$route.query.type === "F") {
        let data = await getDataAnswerUser('F');
        this.$store.commit('numerical/ASSIGN_ANSWER_USER',data);
        this.state_intruction = await this.$store.dispatch("numerical/getQuestions", {
          type: this.$route.query.type,
          lang: this.$route.query.lang,
        });
        this.count_answ = this.$store.state.numerical.questionResponses.length;
      }else if (this.$route.query.type === "G") {
        this.state_intruction = await this.$store.dispatch("jobPreference/getQuestions", {
          type: this.$route.query.type,
          lang: this.$route.query.lang,
        });
        this.count_answ = this.$store.state.jobPreference.questionResponses.length;
      }else if (this.$route.query.type === "H") {
        this.state_intruction = await this.$store.dispatch("survey/getQuestions", {
          type: this.$route.query.type,
          lang: this.$route.query.lang,
        });
        this.count_answ = this.$store.state.survey.questionResponses.length;
      }
      else if (this.$route.query.type === "I") {
        this.state_intruction = await this.$store.dispatch("survey/getQuestions", {
          type: this.$route.query.type,
          lang: this.$route.query.lang,
        });
        this.count_answ = this.$store.state.survey.questionResponses.length;
      }
    },
  };
</script>

<style lang="scss">
.detail-assessment {
  .header-asessment {
    padding: 1.5rem 2rem;
    width: 80%;
    margin: 0 auto;
    img {
      width: 100%;
    }

    .wording {
      align-self: center;
      h3 {
        color: var(--theme-deafult);
      }
    }
  }
  .progress-asessment {
    background-color: #f5f5f5;
    padding: 0.7rem 1rem;

    .progress-bar-asessment {
      width: 80%;
      margin: 0 auto;
      display: flex;

      span {
        font-weight: 500;
      }

      .progress {
        width: 100%;
        align-self: center;
        margin-bottom: 0 !important;
        border-radius: 1rem !important;
        .progress-bar {
          border-radius: 1rem;
        }
      }
    }
  }

  .question-asessment {
    min-height: 500px;
  }
}
</style>
